import React from "react";

export default function Loader({ progress = 0 }) {

    return (
        <div className="custor-loader">

            <div className="loader-bar"/>

            <div className="loader-text">
                Analyzing repository... {Math.round(progress)}%
            </div>

        </div>
    );
}